// extracted by mini-css-extract-plugin
module.exports = {"merchantCreationTitle":"modal-merchant-creation_merchantCreationTitle__osdY0","modalContainer":"modal-merchant-creation_modalContainer__2ZH-M"};